import { handleActions } from "redux-actions";

const initState = {
  isUpdatingVersions: false,
  isUpdatingVersion: false,
  isUpdatedVersion: false,
  isCreatingVersion: false,
};

const reducer = handleActions(
  {
    // GET Products Actions
    REQUESTED_CREATE_VERSION: (state) => ({
      ...state,
      isCreatingVersion: true,
    }),
    RECEIVED_CREATE_VERSION: (state, action) => {
      const newState = {
        ...state,
        isCreatingVersion: false,
      };
      return newState;
    },
    REQUESTED_UPDATE_VERSION: (state, action) => {
      const newState = {
        ...state,
        isUpdatedVersion: false,
        isUpdatingVersion: true,
      };
      return newState;
    },
    RECEIVED_UPDATE_VERSION: (state, action) => {
      const newState = {
        ...state,
        isUpdatedVersion: true,
        isUpdatingVersion: false,
      };
      return newState;
    },
    REQUESTED_UPDATE_VERSIONS: (state, action) => {
      const newState = {
        ...state,
        isUpdatingVersions: true,
      };
      return newState;
    },
    RECEIVED_UPDATE_VERSIONS: (state, action) => {
      const newState = {
        ...state,
        isUpdatingVersions: false,
      };
      return newState;
    },
    REQUESTED_RESET_VERSION_STATUS: (state) => {
      return initState;
    },
  },
  initState
);

export default reducer;
